<template>
  <div class="viewAccount">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-collapse v-model="activeNames" class="collapse-main-content">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ $t('setAccount.viewAccount.corporateInformation') }}
            </div>
          </template>
          <div class="collapse-content">
            <div class="distribution">
              <el-button
                type="primary"
                icon="el-icon-plus"
                class="creatButton"
                v-if="!disabled"
                @click="insertEvent(-1)"
                >{{ $t('setAccount.viewAccount.newLegalEntity') }}</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-delete"
                class="deteButton"
                v-if="!disabled"
                @click="handleDelete('distributionTable')"
                >{{ $t('setAccount.viewAccount.detelLegalEntity') }}</el-button
              >
              <vxe-table
                border
                :auto-resize="true"
                show-overflow
                size="mini"
                ref="distributionTable"
                :data="distriButionData"
                :edit-rules="validRules"
                :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
              >
                <vxe-table-column type="checkbox" width="80"></vxe-table-column>
                <vxe-table-column
                  type="index"
                  :title="$t('currenciesAndCalendar.queryCurrencies.index')"
                  width="80"
                ></vxe-table-column>
                <!-- 法人信息 -->
                <vxe-table-column
                  field="legalEntityCode"
                  :title="$t('setAccount.viewAccount.corporateInformation')"
                  min-width="140"
                  :edit-render="{ type: 'default' }"
                >
                  <template v-slot:edit="scope">
                    <el-select
                      v-model="scope.row.legalEntityCode"
                      @change="changeLegalEntity(scope, scope.row, $event)"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in accountChartCodeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                  <template v-slot="{ row }">{{
                    getSelectLabel(row.legalEntityCode, accountChartCodeList)
                  }}</template>
                </vxe-table-column>
                <!-- 法人代码 -->
                <vxe-table-column
                  field="legalEntityCode"
                  :title="$t('setAccount.viewAccount.legalEntityCode')"
                  min-width="140"
                  :edit-render="{ type: 'default' }"
                >
                </vxe-table-column>
                <!-- 国家 -->
                <vxe-table-column
                  field="legalEntityRegionCode"
                  :title="$t('setAccount.viewAccount.legalEntityRegionCode')"
                  min-width="140"
                  :edit-render="{ type: 'default' }"
                >
                  <template v-slot="{ row }">{{
                    getSelectLabel(row.legalEntityRegionCode, nationalityList)
                  }}</template>
                </vxe-table-column>
                <!-- 统一社会信用代码 -->
                <vxe-table-column
                  field="registrationCode"
                  :title="$t('setAccount.viewAccount.registrationCode')"
                  min-width="140"
                  :edit-render="{ type: 'default' }"
                >
                </vxe-table-column>
                <!-- 地址 -->
                <vxe-table-column
                  field="legalAddress"
                  :title="$t('setAccount.viewAccount.legalAddress')"
                  min-width="140"
                  :edit-render="{ type: 'default' }"
                >
                </vxe-table-column>
              </vxe-table>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ $t('setAccount.accountList.primaryLedger') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('setAccount.accountList.ledgerCode')" prop="ledgerCode">
                  <el-input v-model="ruleForm.ledgerCode" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('setAccount.accountList.ledgerName')" prop="ledgerName">
                  <el-input v-model="ruleForm.ledgerName" :disabled="disabled"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('setAccount.accountList.currency')" prop="currencyName">
                  <el-input v-model="ruleForm.currencyName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('setAccount.accountList.subjectList')"
                  prop="accountChartCode"
                  disabled
                >
                  <el-input v-model="ruleForm.accountChartCode" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item
                  :label="$t('setAccount.viewAccount.defaultExchangeType')"
                  prop="defaultExchangeType"
                >
                  <el-select
                    v-model="ruleForm.defaultExchangeType"
                    :disabled="disabled"
                    :placeholder="$t('setAccount.viewAccount.writeDefaultExchangeType')"
                    filterable
                  >
                    <el-option
                      v-for="(item, index) in defaultExchangeTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ $t('setAccount.viewAccount.accountCalendarCode') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item
                  :label="$t('setAccount.viewAccount.accountCalendarCode')"
                  prop="accountCalendarCode"
                >
                  <el-input v-model="ruleForm.accountCalendarCode" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('setAccount.viewAccount.initOpenPeriod')"
                  prop="initOpenPeriod"
                >
                  <search-table
                    v-model="ruleForm.initOpenPeriod"
                    searchType="calendar"
                    :isMultiple="true"
                    :currentValue="ruleForm.initOpenPeriod"
                    :checkRowKeys="[ruleForm.initOpenPeriod]"
                    :disabled="disabled == true ? true : ledgerStatus == 1 ? true : false"
                    @input="initOpenPeriodChange"
                    :extraData="{
                      calendarCode: ruleForm.accountCalendarCode,
                    }"
                  ></search-table>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div class="fixed-bottom-btnList">
      <el-button class="fixed-bottom-btn" type="primary" @click="edit">{{
        $t('setAccount.viewAccount.create')
      }}</el-button>
      <el-button type="primary" class="fixed-bottom-btn" @click="overEdit">{{
        $t('setAccount.viewAccount.overcreate')
      }}</el-button>
    </div>
  </div>
</template>
<script>
  import API from '@/api/systemManage/accountManage';
  import { mapState } from 'vuex';
  import searchTable from '@/components/form-item/search-table';
  import XEUtils from 'xe-utils';
  export default {
    name: 'distribution',
    components: {
      searchTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        //获取国籍
        nationalityList() {
          return this.$baseRequest.getDictListByType('person_national');
        },
      }),
    },
    data() {
      return {
        rules: {
          ledgerName: [
            {
              required: true,
              message: this.$t('setAccount.viewAccount.writeLedgerName'),
              trigger: 'blur',
            },
          ],
          defaultExchangeType: [
            {
              required: true,
              message: this.$t('setAccount.viewAccount.writeDefaultExchangeType'),
              trigger: 'change',
            },
          ],
          initOpenPeriod: [
            {
              required: true,
              message: this.$t('setAccount.viewAccount.writeInitOpenPeriod'),
              trigger: 'change',
            },
          ],
        },
        validRules: {
          legalEntityCode: [
            {
              required: true,
              message: this.$t('setAccount.viewAccount.changeLegalEntityCode'),
            },
          ],
        },
        disabled: true,
        ledgerStatus: 0,
        activeNames: ['1', '2', '3'],
        ruleForm: {
          ledgerCode: '', //分类账代码
          ledgerName: '', //分类账名称
          currencyName: '', //币种名称
          accountChartCode: '', //科目表代码
          defaultExchangeType: '', //默认汇率类型
          accountCalendarCode: '', //会计日历
          initOpenPeriod: '', //初始打开期间
        },
        initOpenPeriodList: [{ value: '1', label: '期间列表' }], //初始打开期间列表
        defaultExchangeTypeList: [], //默认汇率类型列表
        accountChartCodeList: [], //法人主体列表
        LegalList: [], //已获账套的法人主体
        distriButionData: [], //表格数据
        flag: false,
      };
    },
    mounted() {
      this.getData();
      this.getDictionary();
    },
    methods: {
      initOpenPeriodChange(val) {
        if (val && val.length > 0) {
          this.ruleForm.initOpenPeriod = val[0].periodName;
        } else {
          this.ruleForm.initOpenPeriod = null;
        }
      },
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      changeLegalEntity(scope, row, val) {
        console.log(row, val);
        let legalInfo = this.accountChartCodeList.find((it) => it.value == val);
        console.log(legalInfo);
        row.legalEntityCode = legalInfo.value;
        row.legalEntityName = legalInfo.label;
        row.legalEntityRegionCode = legalInfo.companyNational;
        row.legalAddress = legalInfo.companyAddress;
        row.registrationCode = legalInfo.creditCode;
      },
      //增加
      insertEvent(row) {
        let distributionTable = this.$refs.distributionTable;
        let record = {};
        distributionTable.insertAt(record, row).then(({ row }) => {
          distributionTable.setActiveRow(row);
        });
        this.distriButionData = this.$refs.distributionTable.getTableData().fullData;
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        let flag = selectedList.some((item) => {
          return item.id;
        });
        if (flag) {
          this.$message({
            showClose: true,
            message: this.$t('setAccount.viewAccount.canNotDeletLedger'),
            type: 'error',
          });
        } else {
          if (selectedList.length < 1) {
            this.$message({
              showClose: true,
              message: this.$t('personnel.table.chockedLows'),
              type: 'error',
            });
            return;
          }
          this.$confirmAction()
            .then(() => {
              this.$refs[tableTpye].removeSelecteds();
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('personnel.table.deletSuccess'),
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('personnel.table.deletFalse'),
              });
            });
        }
      },
      //校验
      fullValidEvent() {
        this.flag = true;
        let formList = ['distributionTable', 'ruleForm'];
        let resultArr = [];
        let _self = this;
        function validates(formName) {
          console.log(formName);
          if (formName == 'distributionTable') {
            let result = new Promise((resolve, reject) => {
              _self.$refs[formName]
                .validate()
                .then(() => {
                  resolve();
                })
                .catch(() => reject());
            });
            resultArr.push(result);
          } else {
            let result = new Promise((resolve, reject) => {
              _self.$refs[formName].validate((valid) => {
                valid ? resolve() : reject();
              });
            });
            resultArr.push(result);
          }
        }
        formList.forEach((item) => {
          validates(item); // 循环校验
        });
        this.distriButionData = this.$refs.distributionTable.getTableData().fullData;
        if (this.distriButionData.length <= 0) {
          this.flag = false;
        }
        return Promise.all(resultArr)
          .then(() => {
            if (!this.flag) {
              this.$message({
                showClose: true,
                message: this.$t('personnel.table.tableTitle'),
                type: 'error',
              });
            } else {
              //调保存接口
              this.save();
            }
          })
          .catch(() => {});
      },
      //保存接口
      save() {
        let flag = false;
        //查重操作
        let arr = this.distriButionData.map((i) => i.legalEntityCode);
        if (new Set(arr).size !== arr.length) {
          flag = true;
        }
        if (!flag) {
          let distrsubmitData = this.distriButionData.filter((item) => {
            return item.id == undefined;
          });
          // distrsubmitData.forEach(() => {
          //   item = Object.assign({}, item, this.userInfo.userInfo);
          // });
          let params = Object.assign({}, this.ruleForm, this.userInfo.userInfo);
          params.ledgerLegalEntity = distrsubmitData;
          this.$axios.post(API.UPDATE_LEDGER, params).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.getData();
              this.disabled = true;
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('setAccount.creatAccount.legalEntity'),
            type: 'error',
          });
        }
      },
      //修改
      edit() {
        this.disabled = false;
      },
      //完成
      overEdit() {
        this.fullValidEvent();
      },
      getData() {
        this.$axios.post(API.GET_LEDGER_DETAIL, { id: this.$route.query.id }).then((res) => {
          if (res.data.code == 0) {
            this.ruleForm = res.data.data;
            this.distriButionData = res.data.data.ledgerLegalEntity;
            this.ledgerStatus = res.data.data.ledgerStatus;
            this.$refs['ruleForm'].resetFields();
          }
        });
      },
      getDictionary() {
        this.getCompany();
        this.getLegal();
        this.getExchangeTypeList();
      },
      //获取公司
      async getCompany() {
        const selectStatus = await this.$axios.get(
          API.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.accountChartCodeList = selectStatus.data.data;
          this.accountChartCodeList.forEach((item) => {
            item.legalEntityRegionCode = item.companyNational;
            item.legalAddress = item.companyAddress;
            item.legalEntityCode = item.value;
            item.registrationCode = item.creditCode;
          });
        }
      },
      //获取已分配账套的法人主体
      getLegal() {
        this.$axios.get(API.LIST_ALL_LEDGER_LEGAL_ENTITY).then((res) => {
          if (res.data.code == 0) {
            this.LegalList = res.data.data;
          }
        });
      },
      //获取汇率类型
      async getExchangeTypeList() {
        let params = {
          dictType: 'exchange_type',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.defaultExchangeTypeList = selectStatus.data.data;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .viewAccount .creatButton {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .viewAccount .deteButton {
    background-color: #fe8783 !important;
    border: 1px solid #fe8783 !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .viewAccount .collapse-content {
    padding-top: 10px;
  }
  .viewAccount .demo-ruleForm {
    margin-bottom: 10px;
  }
</style>
